import React from "react";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment-timezone";
import Tooltip from "@material-ui/core/Tooltip";
import WarningIcon from "@material-ui/icons/Warning";
import ScheduledCardStyle from "../../styles/scheduledVisitCardStyle";

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    border: "1px solid #4D4D4D",
    "background-color": "#FFFFFF",
    "box-shadow": "5px 5px 5px 0 rgba(0,0,0,0.5)",
    color: "#242424",
    fontFamily: "Proxima Nova",
    fontSize: "14px",
    letterSpacing: "0",
    lineHeight: "17px",
    minWidth: 573,
  },
}))(Tooltip);

class Card extends React.Component {
  render() {
    let {
      classes,
      data = {},
      src,
      handleRouteChange,
      showSelectedStyle,
      selected,
      routePath,
      isSearchType,
      callStarted,
    } = this.props;
    let { StartDateTime_UTC = new Date(), EndDateTime_UTC = new Date() } = data;
    let timeZone = moment.tz.guess();
    let newDate = moment.tz(StartDateTime_UTC, timeZone).format("L h:mm a");
    let showWarningIcon = new Date() > new Date(EndDateTime_UTC);
    return (
      <div data-view="card" className={classes.cardContainer}>
        <div
          id="card"
          onClick={(e) => handleRouteChange(e, routePath, data)}
          className={`${classes.card} ${
            showSelectedStyle && selected ? classes.cardSelected : ""
          } ${
            callStarted && !selected
              ? classes.disabledCard
              : callStarted && selected
              ? classes.disabledCardCursor
              : ""
          }`}
        >
          <div className={classes.iconTextWrapper}>
            <div className={classes.nameWrapper}>
              <div id="card-call-date" className={classes.dateWrapper}>
                {isSearchType ? null : newDate}
              </div>
              <div
                id="card-name"
                className={`${classes.name}  ${
                  callStarted && !selected ? classes.disabledCardName : ""
                }`}
              >
                {data.FirstName} {data.LastName}
              </div>
            </div>
            <div id="card-icon" className={classes.iconContainer}>
              {showWarningIcon && !isSearchType ? (
                (callStarted && selected) || !callStarted ? (
                  <CustomTooltip
                    placement="right"
                    title="The visit end time has passed, but no Action was taken on the order. Please update order."
                  >
                    <WarningIcon className={classes.doseSpotWarning} />
                  </CustomTooltip>
                ) : (
                  <WarningIcon className={classes.doseSpotWarning} />
                )
              ) : null}
              <img alt="" className={classes.icons} src={src} />
            </div>
          </div>
          <div id="card-storefront-name" className={classes.company}>
            {data.ProductName} ; {data.StoreFrontName}
          </div>
          <div className={classes.dobWrapper}>
            <div id="card-state" className={classes.state}>
              {data.State}
            </div>
            <div id="card-dob" className={classes.Dob}>
              <span className={classes.dobStyle}>DOB :</span>{" "}
              {data.DOB ? data.DOB : ""}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(ScheduledCardStyle)(Card);
